import 'simplebar/dist/simplebar.min.css';
import SimpleBar from 'simplebar-react';
import {styled} from '@mui/material/styles';

export const Scrollbar = styled(SimpleBar)``;
